import React, { useState } from 'react'

import Modal from 'presentation/shared/components/Modal'

import HospitalProfileLayout from 'presentation/hospital/layouts/Profile'

export default function HospitalProfile() {
  const [openSuccessModal, setOpenSuccessModal] = useState<boolean>(false)
  const [updatePasswordSuccess, setUpdatePasswordSuccess] =
    useState<boolean>(false)

  return (
    <>
      <HospitalProfileLayout
        setOpenSuccessModal={setOpenSuccessModal}
        setUpdatePasswordSuccess={setUpdatePasswordSuccess}
      />
      <Modal
        title="Dados atualizado com sucesso"
        show={openSuccessModal}
        close={() => setOpenSuccessModal(false)}
      />

      <Modal
        title="Senha Atualizada"
        show={updatePasswordSuccess}
        close={() => setUpdatePasswordSuccess(false)}
      />
    </>
  )
}
